import ScrollToTop from 'components/UI/ScrollToTop';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DynamicPageBuilder } from '../../pagebuilder/DynamicPageBuilder';
import './HomePage.scss';
function DynamicHomePage() {
    const dispatch = useDispatch();
    const { bannerStrip1, bannerStrip2, homePageElements } = useSelector((state) => state.dynamicHomePage);
    useEffect(() => {
        dispatch({
            type: 'SET_BANNER_STRIPS',
            payload: { page: '/', bannerStrip1, bannerStrip2 },
        });
    }, [bannerStrip1, bannerStrip2, dispatch]);
    return (React.createElement("div", { className: "home-page" },
        React.createElement(ScrollToTop, null),
        React.createElement(DynamicPageBuilder, { elements: homePageElements })));
}
export default DynamicHomePage;
